import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { CreateWebhook } from '@cast/types';

import { getWebhooksQueryKey } from 'hooks/queries/notifications/useGetWebhooksQuery';

export const useCreateWebhookMutation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (config: CreateWebhook) => {
      return apiClient.notifications.createWebhook({ config });
    },
    onSuccess: (_data, { dryRun }) => {
      if (dryRun) {
        notify.success('Test notification sent successfully');
        return;
      }

      queryClient
        .invalidateQueries({ queryKey: getWebhooksQueryKey() })
        .then(() => {
          notify.success('Webhook created successfully');
          onSuccess?.();
        });
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
